import React, { Component } from 'react';
import { isEmpty } from "lodash";
import InputText, { TextArea, InputSelectNative } from '../../../../commonModules/interface/form-input-inline';
import { Box } from '@material-ui/core';

class CommercialHelp extends Component {
    state = {  }
    handleChange = (e) => {
        this.props.handleChange(e)
    }
    render() {
        return (
            <Box >
                <InputSelectNative 
                    onChange={this.handleChange} 
                    value={this.props.actionAlert} 
                    name="actionAlert"
                    label="Action à Réaliser"
                    required
                    options={[
                        <option value="CallClient">Rappeler le Client</option>,
                        <option value="SeeClient">Passer visiter le Client</option>,
                        <option value="RemoveClient">Retirer le kit</option>
                    ]}
                    error={this.props.errors.actionAlert}
                />
                
                <InputSelectNative 
                    onChange={this.handleChange} 
                    value={this.props.agent} 
                    name="agent"
                    label="Agent en charge"
                    required
                    options={!isEmpty(this.props.AGENTS) && Object.values(this.props.AGENTS).map( (agent) => 
                        <option value={agent.id}>{agent.name}</option>
                    )}
                    error={this.props.errors.agent}
                />
                
                
                <InputText
                    type="number" 
                    id="recoveryAmount" 
                    onChange={this.handleChange} 
                    value={this.props.recoveryAmount} 
                    name="recoveryAmount" 
                    label="Montant du recouvrement"
                    required // ?
                    error={this.props.errors.recoveryAmount}
                />

                {this.props.actionAlert === "SeeClient" || this.props.actionAlert === "RemoveClient" &&
                    <InputText
                        type="number" 
                        id="recoveryKm" 
                        onChange={this.handleChange} 
                        value={this.props.recoveryKm} 
                        name="recoveryKm" 
                        label="Km à Parcourir"
                        required
                        error={this.props.errors.recoveryKm}
                    />
                }
                                            
                <TextArea
                    id="comment" 
                    onChange={this.handleChange} 
                    value={this.props.comment} 
                    required
                    name="comment" 
                    rows={5}
                    label="Infos pour le commercial"
                    error={this.props.errors.comment}
                />
            </Box>
        );
    }
}

export default CommercialHelp;